import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getAllArtistExhibitions = (pageId, pageSize, sort, filters, search, artistId, cancelToken=null) => {
  return axios.get(URL_PREFIX + '/artist-exhibitions/', {
          params: {
          artist: artistId,
          ordering: sort,
          search: search,
          page: pageId,
          page_size: pageSize,
          cancelToken: cancelToken?.token
        }
  })
}

export const getArtistExhibition = (id) => {
  return axios.get(URL_PREFIX + '/artist-exhibitions/' + id + '/')
}

export const postArtistExhibition = (param) => {
  return axios.post(URL_PREFIX + '/artist-exhibitions/', param)
}

export const putArtistExhibition = (id, param) => {
  return axios.put(URL_PREFIX + '/artist-exhibitions/' + id + '/', param)
}

export const patchArtistExhibition = (id, param) => {
    return axios.patch(URL_PREFIX + '/artist-exhibitions/' + id + '/', {
      ...param
    })
}

export const deleteArtistExhibition = (id) => {
  return axios.delete(URL_PREFIX + '/artist-exhibitions/' + id + '/')
}
